export const GET_STATS_SUCCESS = 'GET_STATS_SUCCESS'
export const REQUEST = 'REQUEST'
export const FAILURE = 'FAILURE'
